/**
 * @author Aydin Cinar
 */

(function(app) {
    app.filter = (function() {
        var initialized = false;

        var selectors = {
            filterPhoto    : '#filter-photo' ,
            filterVideo    : '#filter-video'
        };



        var init = function() {
            initialized = true;

            app.$objs.filterPhoto  = $(selectors.filterPhoto);
            app.$objs.filterVideo  = $(selectors.filterVideo);

            bind();
        };

        var bind = function() {


            app.$objs.filterPhoto.on('change' , function () {
                togglePhoto();
            });

            app.$objs.filterVideo.on('click' , function () {
                toggleVideo();
            });

        };

        var togglePhoto = function () {

            if( document.getElementById('filter-photo').checked) {
                $('.filter-item-photo').removeClass(app.classes.hidden);
            } else {
                $('.filter-item-photo').addClass(app.classes.hidden);
            }

        };


        var toggleVideo = function () {

            if( document.getElementById('filter-video').checked) {
                $('.filter-item-video').removeClass(app.classes.hidden);
            } else {
                $('.filter-item-video').addClass(app.classes.hidden);
            }

        };


        var isInitialized = function() {
            return initialized;
        };

        return {
            init:          init,
            isInitialized: isInitialized
        };
    })();

    app.registerInit('filter');
})(engelsizyasam);